import * as React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Alert from '@material-ui/lab/Alert'
import { Form, FormitConsumer } from '@oakwood/formit'
import Link from 'components/Link'
import LoadingButton from 'components/LoadingButton'
import Typography from 'components/Typography'
import { useTranslations } from 'containers/Translations/TranslationsContext'
import { useAuth } from '../AuthContext'
import AuthCommonFields from './AuthCommonFields'

export const useStyles = makeStyles((theme) => ({
  header: {},
  main: {},
  footer: {},
  alert: { marginTop: theme.spacing(1) },
  submitButton: theme.mixins.inputMargin('normal'),
}))

function AuthRecoverPassword(props) {
  const classes = useStyles(props)
  const { onLoginOrRegisterScreenToggle, infoData, formitError } = useAuth()
  const t = useTranslations()

  return (
    <>
      <div className={classes.header}>
        <Typography component="h1" variant="h5">
          {t('Web.AuthRecoverPassword.RecoverPassword')}
        </Typography>
      </div>

      <Form className={classes.main}>
        <AuthCommonFields />

        <FormitConsumer>
          {({ isSubmitting }) => (
            <LoadingButton
              className={classes.submitButton}
              pending={isSubmitting}
              variant="outlined"
              type="submit"
              fullWidth
            >
              {t('Web.AuthRecoverPassword.RecoverPassword.Button')}
            </LoadingButton>
          )}
        </FormitConsumer>

        {(infoData || formitError) && (
          <Alert className={classes.alert} severity="success">
            {t('Web.AuthLoginEmail.ForgotPasswordMessage')}
          </Alert>
        )}
      </Form>

      <div className={classes.footer}>
        <Typography>{t('Web.AuthRecoverPassword.NoAccount')}</Typography>

        <Link // eslint-disable-line jsx-a11y/anchor-is-valid
          onClick={onLoginOrRegisterScreenToggle}
          component="button"
          type="button"
          underline="always"
          variant="body1"
        >
          {t('Web.AuthRecoverPassword.SignUp')}
        </Link>
      </div>
    </>
  )
}

export default AuthRecoverPassword
